import { render, staticRenderFns } from "./minimal.vue?vue&type=template&id=157c266c&scoped=true"
import script from "./minimal.vue?vue&type=script&lang=js"
export * from "./minimal.vue?vue&type=script&lang=js"
import style0 from "./minimal.vue?vue&type=style&index=0&id=157c266c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157c266c",
  null
  
)

export default component.exports